import styles from "./styles.module.sass";

export function Skeleton() {
  return <div className={styles.Skeleton} />;
}
